// Utils
import limitValue from '../../utils/numbers/limitValue';
/**
 * Calculate centered popup position from current position and window size
 *
 * @deprecated Do not use legacy components anymore.
 * @param {number} popupWidth Width of the popup
 * @param {number} popupHeight Height of the popup
 * @param {BasePosition} basePosition Position the popup should relative to
 * @returns {FormBoxPosition} The new x, y coordinates of the popup
 */
export var getCenteredPopupPosition = function (popupWidth, popupHeight, basePosition) {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    // Default is the center position
    var posX = (windowWidth - popupWidth) / 2;
    var posY = (windowHeight - popupHeight) / 2;
    // If we have a base position defined we should place the popup relative to that
    if (basePosition) {
        switch (true) {
            case Object.prototype.hasOwnProperty.call(basePosition, 'left'):
                posX = basePosition.left;
                break;
            case Object.prototype.hasOwnProperty.call(basePosition, 'right'):
                posX = basePosition.right;
                break;
            case Object.prototype.hasOwnProperty.call(basePosition, 'centerX'):
                posX = basePosition.centerX - popupWidth / 2;
                break;
            default:
                break;
        }
        switch (true) {
            case Object.prototype.hasOwnProperty.call(basePosition, 'top'):
                posY = basePosition.top;
                break;
            case Object.prototype.hasOwnProperty.call(basePosition, 'bottom'):
                posY = windowHeight - basePosition.bottom - popupHeight;
                break;
            case Object.prototype.hasOwnProperty.call(basePosition, 'centerY'):
                posY = basePosition.centerY - popupWidth / 2;
                break;
            default:
                break;
        }
    }
    // If the position is negative we should set to zeo to prevent the popup going off the screen
    posX = limitValue(posX, 0, windowWidth - popupWidth);
    posY = limitValue(posY, 0, windowHeight - popupHeight);
    return { x: posX, y: posY };
};
//# sourceMappingURL=getCenteredPopupPosition.js.map